/**
 * 経過月数の計算
 * @param {Date} start
 * @param {Date} end
 * @returns {number}
 */
export const calculateTermMonth = (start: Date, end: Date): number => {
  return (
    (end.getFullYear() - start.getFullYear()) * 12 +
    (end.getMonth() - start.getMonth()) +
    1
  );
};
